import { renderMarkdown } from "@/lib/markdown";
import { cn } from "@/lib/utils";

interface MarkdownArticleProps {
  markdown: string;
  className?: string;
}

/**
 * Renders stored report Markdown. The HTML is sanitized with DOMPurify inside
 * `renderMarkdown`; the arbitrary-variant classes style the injected elements
 * since Tailwind utilities can't be attached to them directly.
 */
export function MarkdownArticle({ markdown, className }: MarkdownArticleProps) {
  return (
    <article
      className={cn(
        "text-foreground text-sm leading-relaxed",
        "[&_h1]:font-heading [&_h1]:text-primary [&_h1]:mt-8 [&_h1]:mb-3 [&_h1]:text-3xl [&_h1]:font-normal [&_h1]:tracking-tight [&_h1:first-child]:mt-0",
        "[&_h2]:font-heading [&_h2]:text-primary [&_h2]:mt-8 [&_h2]:mb-3 [&_h2]:text-2xl [&_h2]:font-normal [&_h2]:tracking-tight [&_h2:first-child]:mt-0",
        "[&_h3]:font-heading [&_h3]:text-primary [&_h3]:mt-6 [&_h3]:mb-2 [&_h3]:text-lg [&_h3]:font-normal",
        "[&_p]:my-3",
        "[&_ul]:my-3 [&_ul]:list-disc [&_ul]:pl-6",
        "[&_ol]:my-3 [&_ol]:list-decimal [&_ol]:pl-6",
        "[&_li]:my-1",
        "[&_blockquote]:border-accent [&_blockquote]:text-muted-foreground [&_blockquote]:my-4 [&_blockquote]:border-l-2 [&_blockquote]:pl-4",
        "[&_code]:bg-background [&_code]:rounded [&_code]:px-1 [&_code]:py-0.5 [&_code]:font-mono [&_code]:text-[13px]",
        "[&_table]:my-4 [&_table]:w-full [&_table]:border-collapse",
        "[&_th]:border-border [&_th]:border [&_th]:px-3 [&_th]:py-2 [&_th]:text-left [&_th]:font-semibold",
        "[&_td]:border-border [&_td]:border [&_td]:px-3 [&_td]:py-2",
        "[&_hr]:border-border [&_hr]:my-6",
        "[&_a]:text-accent [&_a]:underline",
        "[&_strong]:text-primary [&_strong]:font-bold",
        className,
      )}
      dangerouslySetInnerHTML={{ __html: renderMarkdown(markdown) }}
    />
  );
}
